import React from 'react';

const Popin = ({
                   prenom,
                   email
               }) => {
    console.log(prenom, email)
    return (
        <div>
            <div className={"contactFormContainer"}>
                <div className={"contactForm"}>
                    <h1 style={{textAlign: "center"}}>Félicitations, votre formulaire a bien été envoyé !</h1>
                    <p style={{fontWeight: "400"}}>Merci {prenom.current.value} pour votre demande ! Nous vous avons
                        envoyé une confirmation par
                        e-mail à
                        l’adresse : {email.current.value} (pensez à vérifier vos spams/courriers indésirables). <br/>À
                        bientôt !
                    </p>
                </div>
            </div>

        </div>
    );
};

export default Popin;